import { defineSlotRecipe } from "@pandacss/dev";
import { selectAnatomy } from "@ark-ui/react";
import { fieldDefaultRecipeDefinition } from "./utils/fieldDefaultRecipeDefinition";

export const aromaDropdown = defineSlotRecipe({
  className: "aroma-dropdown",
  jsx: ["Dropdown", "maxHeight"],
  slots: selectAnatomy.keys(),
  base: {
    root: {
      position: "relative",
      width: "100%",
    },
    trigger: {
      ...fieldDefaultRecipeDefinition.base,
      alignItems: "center",
      transition:
        "border-color ease-in-out .15s, box-shadow ease-in-out .15s, background-color ease-in-out .15s",
      _open: {
        borderColor: "border.brand-bold",
      },
      _focusVisible: {
        shadow: "effect.focus-ring.brand",
        borderColor: "border.brand-bold",
      },
      "&[data-readonly]:not([data-disabled])": {
        cursor: "not-allowed",
        border: "none",
        bg: "background.neutral.base.subtle",
        _hover: {
          bg: "background.neutral.base.subtle",
        },
      },
      _disabled: {
        cursor: "not-allowed",
      },
    },
    indicator: {
      display: "flex",
      _aromaticonChildren: {
        alignSelf: "center",
        fontSize: "{sizes.xs}",
      },
      color: {
        _disabled: "content.neutral.base.disable",
        "&[data-readonly]:not([data-disabled])": "content.neutral.base.disable",
      },
    },
    valueText: {
      alignSelf: "center",
      textStyle: "paragraph.m.regular",
      width: "100%",
      color: "content.neutral.base.bold",
      textAlign: "justify",
      _placeholder: {
        color: "content.neutral.base.subtlest",
      },
      _disabled: {
        color: "content.neutral.base.disable",
        _placeholder: {
          color: "content.neutral.base.disable",
        },
      },
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.1",
      bg: "background.neutral.base.subtlest",
      color: "content.neutral.base.bold",
      outline: "none",
      borderWidth: "m",
      borderStyle: "solid",
      borderColor: "border.neutral.subtle",
      px: "padding.3",
      py: "padding.2",
      borderRadius: "l",
      overflowY: "auto",
      overflowX: "hidden",
    },
    item: {
      height: "{sizes.xl}",
      paddingX: "padding.3",
      display: "flex",
      gap: "gap.2",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      borderRadius: "l",
      flexShrink: 0,
      bg: {
        _hover: "background.neutral.base.subtlest-hover",
        _disabled: "background.neutral.disable.subtle",
      },
    },
    itemText: {
      display: "flex",
      alignItems: "center",
      gap: "gap.2",
      color: {
        base: "content.neutral.base.bold",
        _disabled: "content.neutral.base.disable",
      },
      _aromaticonChildren: {
        fontSize: "{sizes.xs}",
      },
    },
    itemIndicator: {
      fontSize: "{sizes.xs}",
      color: "content.brand.bold",
    },
  },
  variants: {
    size: {
      small: {
        trigger: fieldDefaultRecipeDefinition.variants?.size.small.container,
      },
      medium: {
        trigger: fieldDefaultRecipeDefinition.variants?.size.medium.container,
      },
    },
    status: {
      error: {
        trigger: {
          ...fieldDefaultRecipeDefinition.variants?.status.error.container,

          _hover: {
            backgroundColor: "background.neutral.base.subtlest-hover",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.error",
          },
          _open: {
            borderColor: "border.functional.error",
          },
        },
      },
      warning: {
        trigger: {
          ...fieldDefaultRecipeDefinition.variants?.status.warning.container,

          _hover: {
            backgroundColor: "background.neutral.base.subtlest-hover",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.warning",
          },
          _open: {
            borderColor: "border.functional.warning",
          },
        },
      },
    },
    iconOnly: {
      true: {
        trigger: {
          width: "min-content",
          justifyContent: "center",
          alignItems: "center",
          padding: "calc({spacing.padding.1} + {borderWidths.l})",
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
  },
});
